var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.317 27.65L21.9503 20L14.317 12.35L16.667 10L26.667 20L16.667 30L14.317 27.65Z","fill":"#202023"}));
}

ChevronRight.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
